<template>
  <div class="app-container calendar-list-container">
    <!-- <basic-container> -->
    <div class="top-header">
      <div class="left" @click="$router.push('/')">
        <img src="@/static/zflogo.png" alt="" />
      </div>
      <div class="right">
        <el-tooltip
          v-if="this.userInfo.avatar"
          effect="dark"
          content="用户头像"
          placement="bottom"
        >
          <div class="top-bar__item">
            <img id="thumbnail" class="top-bar__img" :src="userInfo.avatar" />
          </div>
        </el-tooltip>
        <el-dropdown>
          <span class="el-dropdown-link">
            <div class="top-bar__item text">
              {{ userInfo.username }}
            </div>
            <img src="@/static/topbar/down.png" class="down" alt="" />
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div class="user-info">
                <img
                  id="thumbnail"
                  class="top-bar__img"
                  :src="userInfo.avatar"
                />
                <div class="user-info-right">
                  <div class="user-info-top">
                    <div class="user-info-top-title">
                      {{ userInfo.username }}
                    </div>
                    <div class="user-info-top-tag" v-if="roleType==2">
                      {{ userInfo.companyInfo.companyPositionName }}
                    </div>
                  </div>
                  <div class="user-info-bottom">{{ userInfo.phone }}</div>
                </div>
              </div>
            </el-dropdown-item>

            <el-dropdown-item
              v-if="list && list.length > 0"
              @click.native="$router.push({ path: '/changeCompany' })"
            >
              切换企业
              <!-- <router-link to="/changeCompany"></router-link> -->
            </el-dropdown-item>
            <el-dropdown-item @click.native="$router.push({ path: '/info' })">
              个人信息
              <!-- <router-link to="/info"></router-link> -->
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout"
              >退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
          <el-dialog title="我的权限" :visible.sync="dialogMenuTree">
            <el-tree
              class="filter-tree"
              :data="menuTree"
              node-key="id"
              highlight-current
              :props="defaultProps"
              ref="menuTree"
            >
            </el-tree>
          </el-dialog>
        </el-dropdown>
      </div>
    </div>
    <div class="info-content">
      <div class="left">
        <div class="tabs">
          <div
            class="tab-item"
            :class="{ active: curTab == 1 }"
            @click="curTab = 1"
          >
            账号设置
          </div>
          <div
            class="tab-item"
            :class="{ active: curTab == 2 }"
            @click="curTab = 2"
          >
            偏好设置
          </div>
        </div>
      </div>
      <div class="right-wrapper" v-if="curTab == 1">
        <div class="right">
          <div class="block1">
            <div class="title">账号设置</div>
            <div class="block1-content">
              <img :src="ruleForm.avatar" alt="" />
              <div class="name">
                {{ ruleForm.username }}
              </div>

              <div class="right-text" @click="changeAvatar">更换头像</div>
            </div>
          </div>
          <div class="block2" v-if="roleType==2">
            <div class="label">注册企业</div>
            <div class="value">{{ userInfo.companyInfo.companyAuthName }}</div>
          </div>
          <div class="block3">
            <div class="label">手机号(账号)</div>
            <div class="value">
              {{ userInfo.phone }}
            </div>
          </div>
        </div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
      <div class="right-wrapper" v-if="curTab == 2">
        <div class="right">
          <div class="right-title">偏好设置</div>

          <topTheme v-if="curTab == 2"></topTheme>

          <topColor v-if="curTab == 2"></topColor>
        </div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
    </div>

    <el-dialog
      :title="doType == '2' ? '绑定手机号' : '解绑手机'"
      :visible.sync="dialogBindPhone"
      :close-on-click-modal="false"
      width="30%"
    >
      <codePhone :type="doType" :phone="phone" @handleDone="handleBindPhone" />
    </el-dialog>
    <!-- </basic-container> -->
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import { fetchTree } from "@/api/upms/organ";
import { delObj, pageByUserId as getPage } from "@/api/upms/log";
import { tableOption } from "@/const/crud/upms/log";
import { tableOption as tableOption2 } from "@/const/crud/upms/loglogin";
import {
  pageByUserId as getPage2,
  delObj as delObj2,
} from "@/api/upms/loglogin";
import { editObj, bindPhone, uploadAvatar } from "@/api/upms/user";
import codePhone from "@/components/code-phone/main.vue";
import { fetchMenuTree } from "@/api/upms/menu";
import topColor from "@/page/index/top/top-color.vue";
import topTheme from "@/page/index/top/top-theme.vue";
export default {
  name: "info",
  components: {
    codePhone,
    topColor,
    topTheme,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.ruleForm.password !== "") {
        if (value !== this.ruleForm.newpassword1) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      curTab: 1,
      dialogMenuTree: false,
      menuTree: [],
      list: [],
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [],
        descs: "create_time",
      },
      tableLoading: false,
      tableOption: tableOption,
      tableData2: [],
      page2: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [],
        descs: "create_time",
      },
      tableLoading2: false,
      tableOption2: tableOption2,
      treeOrganData: [],
      organProps: {
        label: "name",
        value: "id",
      },
      optionAvatar: {
        emptyBtn: false,
        submitBtn: false,
        labelWidth: 120,
        column: [
          {
            prop: "avatar",
            type: "upload",
            listType: "picture-img",
            action: "/upms/file/upload?fileType=image&dir=user/",
            propsHttp: {
              url: "link",
            },
            loadText: "附件上传中，请稍等",
            span: 24,
            tip: "只能上传jpg/png文件，且不超过500kb",
          },
        ],
      },
      switchStatus: "",
      show: false,
      headers: {
        Authorization: "Bearer " + store.getters.access_token,
        AuthorizationMD5: store.getters.user_md5, // user_md5
      },
      phone: null,
      ruleForm: {
        username: "",
        password: "",
        newpassword1: "",
        newpassword2: "",
        avatar: "",
        email: "",
      },
      rules: {
        password: [
          {
            required: true,
            min: 6,
            message: "原密码不能为空且不少于6位",
            trigger: "change",
          },
        ],
        newpassword1: [
          {
            required: true,
            min: 8,
            message: "密码必须长度大于8位且包含大小写字母/数字/符号！",
            trigger: "change",
            pattern:
              /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/,
          },
        ],
        newpassword2: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      },
      dialogBindPhone: false,
      doType: null,
    };
  },
  created() {
    this.ruleForm.id = this.userInfo.id;
    this.ruleForm.organId = this.userInfo.organId;
    this.ruleForm.username = this.userInfo.username;
    this.phone = this.userInfo.phone;
    this.ruleForm.email = this.userInfo.email;
    this.ruleForm.avatar =
      this.userInfo.avatar != null ? this.userInfo.avatar : "";
    console.info(this.userInfo);
    this.switchStatus = "userManager";
    this.handleOrgan();
    let list = sessionStorage.getItem("companyUser");
    if (list) {
      this.list = JSON.parse(list);
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    ...mapGetters(["permissions","roleType"]),
    permissionList() {
      return {
        delBtn: this.permissions["sys:log:del"] ? true : false,
      };
    },
    permissionList2() {
      return {
        addBtn: this.permissions["sys:loglogin:add"] ? true : false,
        delBtn: this.permissions["sys:loglogin:del"] ? true : false,
        editBtn: this.permissions["sys:loglogin:edit"] ? true : false,
        viewBtn: this.permissions["sys:loglogin:get"] ? true : false,
      };
    },
  },
  methods: {
    changeAvatar() {
      var input = document.createElement("input"); // 创建一个input标签
      input.type = "file"; // 设置input类型
      input.name = this.fileName; // this.fileName只是个父组件传过来的名字，这个可以随便起
      input.accept = "image/jpeg, image/png, image/jpg, image/gif"; // 添加input传入参数的限制
      input.onchange = this.onFileChange;
      //this.onFileChange因为我这个是个子组件所以需要$emit触发父组件方法，this.onFileChange里面的内容是通过$emit触发父组件方法
      input.click(); // 触发input输入框弹出选择文件的框
    },
    onFileChange(event) {
      const file = event.target.files[0]; // 获取选择的文件

      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        uploadAvatar(formData).then((res) => {
          this.ruleForm.avatar = res.data.link;
          this.submitForm("ruleForm");
        });
        // 你可以进一步处理文件，比如上传到服务器或显示文件信息等
      }
    },
    showMenuTree() {
      this.dialogMenuTree = true;
      fetchMenuTree().then((response) => {
        let menuTree = response.data.data;
        this.menuTree = menuTree;
      });
    },
    logout() {
      this.$confirm("是否退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          // if(this.$store.getters.userType == 1){
          this.$router.push({ path: "/login" });
          // }else{
          //   this.$router.push({path: "/buildLogin"});
          // }
        });
      });
    },
    handleBindPhone(loginForm, type) {
      bindPhone(
        Object.assign(
          {
            id: this.ruleForm.id,
            doType: type,
          },
          loginForm
        )
      ).then((response) => {
        if (response.data.code == 0) {
          let message = "";
          if (type == "2") {
            this.phone = loginForm.phone;
            message = "绑定成功";
          } else {
            this.phone = null;
            message = "解绑成功";
          }
          this.dialogBindPhone = false;
          this.$store.dispatch("GetUserInfo");
          this.$notify({
            title: "成功",
            message: message,
            type: "success",
            duration: 2000,
          });
        }
      });
    },
    showBindPhone(doType) {
      this.doType = doType;
      this.dialogBindPhone = true;
    },
    handleOrgan() {
      fetchTree().then((response) => {
        this.treeOrganData = response.data.data;
      });
    },
    switchTab(tab, event) {
      this.switchStatus = tab.name;
    },
    submitForm(formName) {
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      editObj(this.ruleForm)
        .then((response) => {
          if (response.data.data) {
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success",
              duration: 2000,
            });
            // 修改密码之后强制重新登录
            if (this.switchStatus === "passwordManager") {
              this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
            }
          } else {
            this.$notify({
              title: "失败",
              message: response.data.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "失败",
            message: "修改失败",
            type: "error",
            duration: 2000,
          });
        });
      //   } else {
      //     return false;
      //   }
      // });
    },
    handleAvatarSuccess(res, done, loading) {
      this.ruleForm.avatar = res.url;
      done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
            // createId: this.userInfo.id
          },
          params
        )
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
        this.page.currentPage = page.currentPage;
        this.page.pageSize = page.pageSize;
        this.tableLoading = false;
      });
    },
    handleDel: function (row, index) {
      var _this = this;
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          this.getPage(this.page);
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
        })
        .catch(function (err) {});
    },
    /**
     * 搜索回调
     */
    searchChange(form, done) {
      this.getPage(this.page, form);
      done();
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },

    searchChange2(params, done) {
      params = this.filterForm(params);
      this.page2.currentPage = 1;
      this.getPage2(this.page2, params);
      done();
    },
    sortChange2(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page2.descs = [];
        this.page2.ascs = prop;
      } else if (val.order == "descending") {
        this.page2.ascs = [];
        this.page2.descs = prop;
      } else {
        this.page2.ascs = [];
        this.page2.descs = [];
      }
      this.getPage2(this.page2);
    },
    getPage2(page, params) {
      this.tableLoading2 = true;
      getPage2(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page2.descs,
            ascs: this.page2.ascs,
            // createId: this.userInfo.id
          },
          params
        )
      )
        .then((response) => {
          this.tableData2 = response.data.data.records;
          this.page2.total = response.data.data.total;
          this.page2.currentPage = page.currentPage;
          this.page2.pageSize = page.pageSize;
          this.tableLoading2 = false;
        })
        .catch(() => {
          this.tableLoading2 = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel2: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj2(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage2(this.page2);
        })
        .catch(function (err) {});
    },
    /**
     * 刷新回调
     */
    refreshChange2(page) {
      this.getPage2(this.page2);
    },
  },
};
</script>
<style lang="scss" scoped>

.app-container {
  background: #ededf0;
  width: 100%;
  height: 100%;
  margin-top: 56px;
}
.top-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 0 23%;
  height: 56px;
  width: 852px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top-header {
  cursor: pointer;
  .left {
    width: 78px;
    height: 28px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
::v-deep.top-bar__item {
  height: auto;
  cursor: pointer;
}
.info-content {
  display: flex;
  padding: 0 23%;
  padding-top: 60px;
  width: 852px;
  .left {
    width: 172px;
    height: fit-content;
    border-radius: 4px;
    padding-top: 25px;
    padding-bottom: 10px;
    background: #fff;
    cursor: pointer;
    margin-right: 24px;
    .tabs {
      .tab-item {
        padding-left: 20px;
        margin-bottom: 14px;
        font-weight: 400;
        font-size: 16px;
        color: #626266;
        &.active {
          padding-left: 19px;
          font-weight: 500;
          font-size: 16px;
          color: #313133;
          border-left: 1px solid #474a59;
        }
      }
    }
  }
  .right-wrapper {
    width: 656px;
  }
  .right {
    // width: 656px;
    height: 640px;
    background: #ffffff;
    border-radius: 4px;
    .right-title {
      font-weight: 500;
      font-size: 18px;
      color: #313133;
      margin-bottom: 8px;
      padding: 32px;
    }
    .block1 {
      padding: 32px;
      padding-bottom: 24px;
      border-bottom: 1px solid #ededf0;
      .title {
        font-weight: 500;
        font-size: 18px;
        color: #313133;
        margin-bottom: 24px;
      }
      .block1-content {
        display: flex;
        align-items: center;
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .name {
          font-weight: 400;
          font-size: 14px;
          color: #313133;
        }
        .right-text {
          font-weight: 400;
          font-size: 14px;
          color: #35b1ff;
          margin-left: auto;
          cursor: pointer;
        }
      }
    }
    .block2,
    .block3 {
      padding: 24px 32px;
      border-bottom: 1px solid #ededf0;
      .label {
        font-weight: 400;
        font-size: 14px;
        color: #939399;
        margin-bottom: 6px;
      }
      .value {
        font-weight: 400;
        font-size: 14px;
        color: #313133;
      }
    }
  }
  .back {
    cursor: pointer;
    margin: 0 auto;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #c8c8cc;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
@media only screen and (max-width: 1440px) , (max-height: 800px){
  .top-header {
    transform: scale(0.9);
  }
  .info-content {
    transform: scale(0.9);
    padding-top: 0;
  }
  .back{
    margin-top: 20px!important;
  }
}
.user-info {
  display: flex;
  // border-bottom: 1px solid #EDEDF0;
  // align-items: center;
  .top-bar__img {
    margin-right: 6px;
    margin-top: 3px;
  }
  .user-info-right {
    .user-info-top {
      display: flex;
      align-items: center;
      .user-info-top-title {
        font-weight: 400;
        font-size: 14px;
        color: #313133;
        margin-right: 4px;
      }
      .user-info-top-tag {
        line-height: 18px;
        padding: 0 4px;
        height: 18px;
        font-weight: 400;
        font-size: 10px;
        color: #666666;
        background: #ebebeb;
        border-radius: 1px;
      }
    }
    .user-info-bottom {
      font-weight: 400;
      font-size: 12px;
      color: #626266;
      margin-top: -8px;
    }
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
